export const NS = 'wiffle-st';

export const ACTIVE_GAME = `${NS}.active-game`;

export const SAVES = `${NS}.saves`;
export const SAVE_PREFIX = `${NS}.save.`;

export const TEAMS = `${NS}.teams`;
export const TEAM_PREFIX = `${NS}.team.`;
